module.exports = __webpack_public_path__ + "static/img/mo_btn2.beb2492.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/mo_btn2.png
// module id = 4BY3
// module chunks = 7